<template>
    <div class="step-progress-bar">
        <p class="step-title">Step {{ step }}: <b>{{ stepTitle }}</b></p>
        <div class="step-progress">
            <span :class="{'step-status': true, active: step >= index}" v-for="index in stepCount" :key="index"/>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    step: Number,
    stepCount: Number,
    stepTitle: String,
  }
}

</script>

<style lang="scss" scoped>
@import './variables';

.step-progress-bar {
  display: flex;
  flex-direction: column;
  align-items: center;

  .step-title {
    white-space: nowrap;
    font-size: 16px;
    color: $title-grey;
    b {
      color: $title-dark-grey;
    }
  }

  .step-progress {
    display: flex;
    margin-top: 8px;
    .step-status {
      width: 12px;
      height: 4px;
      background: $light-blue9;
      margin-right: 8px;
      border-radius: 3px;
      &:last-child {
        margin: 0;
      }
      &.active {
        background: $light-blue2;
      }
    }
  }
}

</style>